import { formatContractSumDisplay } from './table';

export type PaymentControlLight = 'green' | 'yellow' | 'red';

export function spentLookupKey(taskId: string, article: string): string {
  return `${taskId.trim()}||${article.trim()}`;
}

export function formatSignedSum(value: number): string {
  const formatted = formatContractSumDisplay(Math.abs(value));
  if (value > 0) {
    return `+${formatted}`;
  }
  if (value < 0) {
    return `-${formatted}`;
  }
  return formatted;
}

export function getPaymentControlLight(
  plan: number | null,
  delta: number | null,
  requested: number,
): PaymentControlLight {
  if (plan == null || delta == null) {
    return 'yellow';
  }
  const projected = delta + requested;
  if (projected > plan) {
    return 'red';
  }
  return 'green';
}
